import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ToastrService } from 'ngx-toastr';
import { ContentManagementService } from './shared/services/content-management.service';

@Component({
  selector: 'app-content-management',
  templateUrl: './content-management.component.html',
  styleUrls: ['./content-management.component.css']
})
export class ContentManagementComponent implements OnInit {

  contentMgmtData : any;
  pages : any[] = [];
  config : AngularEditorConfig;
  constructor(private _contentMgmtSvc : ContentManagementService, private _toastrSvc : ToastrService) { }

  ngOnInit() {
    //this.editorConfiguration();
    this.getContentMangement();
  }

  editorConfiguration(){
    return this.config  = {
      editable: true,
      spellcheck: true,
      height: '15rem',
      minHeight: '5rem',
      placeholder: 'Enter text here...',
      translate: 'no',
      defaultParagraphSeparator: 'p',
      defaultFontName: 'Arial',
      toolbarHiddenButtons: [
        ['bold']
        ],
      customClasses: [
        {
          name: "quote",
          class: "quote",
        },
        {
          name: 'redText',
          class: 'redText'
        },
        {
          name: "titleText",
          class: "titleText",
          tag: "h1",
        },
      ]
  };
  }
  getContentMangement(){
    this._contentMgmtSvc.getContentManagementData().subscribe(data => {
      if(data){
        this.pages = data.Pages;
        this.contentMgmtData = data;
      }
    })
  }

  getPage(){
    this._contentMgmtSvc.getContentManagementByPageID(this.contentMgmtData.ID).subscribe(data => {
      if(data){
        this.contentMgmtData = data;
      }
    });
  }

  save(){
    this.contentMgmtData.Pages = this.pages;
    this._contentMgmtSvc.saveContentManagement(this.contentMgmtData).subscribe(data => {
      if(data){
        if(data.ResultMessages.length > 0){
          data.ResultMessages.forEach(element => {
            this._toastrSvc.error(element.Message);
          });
        }
        else{
          this.contentMgmtData = data;
          this._toastrSvc.success("Page Contents saved successfully.");
        }
      

      }
     
    })
  }
}
